module.exports = __webpack_public_path__ + "assets/images/arrow.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/arrow.svg
// module id = 503
// module chunks = 0